import { IconRotate } from "@tabler/icons-react";
import styles from "../Feed.module.css";
import Button from "../../../../components/UI/Button/button";

const EmptyState = ({ icon: Icon, title, message, showReset, onReset }) => {
  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyIcon}>
        <Icon size={30} />
      </div>
      <h3>{title}</h3>
      <p>{message}</p>
      {showReset && (
        <Button
          variant="secondary"
          leftIcon={<IconRotate size={15} />}
          onClick={onReset}
          style={{ marginTop: 12 }}
        >
          Clear filters
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
